import { ExpiringBanksList } from "Components/Banking/Auth/ExpiringBanksList";
import { useBankingAuth } from "Hooks/useBankingAuth";
import type { BankEnvironment } from "Infrastructure/Api/Api";

type Props = {
  environments: Array<BankEnvironment>;
};

export const ExpiringAisBanksList = ({ environments }: Props) => {
  const { authorize, isPending, selectedEnvironment } = useBankingAuth();

  return (
    <ExpiringBanksList
      environments={environments}
      authorize={authorize}
      isPending={isPending}
      selectedEnvironment={selectedEnvironment}
    />
  );
};
